import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Feeback from './PrototypeFeedback';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeMultipleChoice extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            character_label: appHelper.getLocaleString("character_label"),
            you_label: appHelper.getLocaleString("you_label"),
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }


    render() {
        return (
            <div className="learner-action">
                <div className="question-wrapper">
                    <div className="object-container" style={{marginBottom: 0}}>
                    <div className={`prototype question-prompt`}
                             dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_CHARACTER_CHOICE_PROMPT_TEXT}}/>
                    </div>
                        <div className={`prototype multiple-choice-option-list user theme-active question-checked`}>
                            <div className={`multiple-choice-option selected answered  reflective rounded`}
                                 style={{height: "auto"}}>
                                <input type="radio" name="prototype-conversation-field" disabled="disabled"/>
                                <label htmlFor={`prototype-conversation-field`}>
                                    <span
                                        dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_CHARACTER_CHOICE_RESPONSE_TEXT}}/>
                                </label>
                            </div>
                        </div>

                        <Feeback/>

                </div>
            </div>
        );
    }
}

PrototypeMultipleChoice.propTypes = {
    locale: PropTypes.object,
};

PrototypeMultipleChoice.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeMultipleChoice);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeMultipleChoice.js
 **/